import { render, staticRenderFns } from "./CustomerShowDetailsTab.vue?vue&type=template&id=4601e64c"
import script from "./CustomerShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports